
import React, { Component } from 'react';
import { MyContext } from '../../../../context';
import {
    TextField, Stack, DefaultButton, PrimaryButton, CommandBarButton, Dropdown, Toggle, Spinner, TeachingBubble, Separator, IconButton, Layer
} from 'office-ui-fabric-react';
import { getSearchAreaTypeEnum } from '../../PolicyRules/PolicyRulesQuery';
import { updateScorecard, getAllVersionOfScorecard, queryScorecard, restoreScorecard } from "../AIQualityManagementQuery"
import EditScorecardSection from './EditScorecardSection';
import { Query } from 'react-apollo';
import AlertBar from '../../../CustomComponents/AlertBar';
import ScorecardFolding from '../../../DetailView/DetailPivot/PivotElements/QualityManagement/ScorecardFolding';
import EditScorecardSettings from './EditScorecardSettings';
import * as UtilityScorecard from '../UtilityScorecard'
import Papa from 'papaparse';


export default class EditScorecard extends Component {

    static contextType = MyContext

    constructor(props) {
        super(props);
        const scorecard = this.props.data !== undefined ? this.props.data : null
        const defaultSettingItems = UtilityScorecard.getDefaultSettingItems()
        this.state = {
            //page data
            processing: false,
            csvError: null,
            isHovered: false,
            showTeachingBubbleUpload: false,
            selectCriteria: "section",
            allAvailableAreas: [],
            availableAreas: [],
            selectedOtherVersion: false,
            selectedVersion: scorecard !== null ? scorecard.id : null,
            processingVersion: false,
            alertAutomatedEvaluation: false,
            selectedKey: scorecard !== null ? [] : ["elements"],
            openModalColor: false,
            selectedKeySection: [],
            // scorecard data
            id: scorecard !== null ? scorecard.id : null,
            name: scorecard !== null ? scorecard.name : "",
            description: scorecard !== null ? scorecard.description : "",
            sections: scorecard !== null ? UtilityScorecard.cleanSectionsItems(scorecard.sections) : [],
            automatedEvaluation: scorecard !== null ? scorecard.automatedEvaluation : false,
            masterItemId: scorecard !== null ? scorecard.masterItemId : null,
            version: scorecard !== null ? scorecard.version : 0,
            selected: scorecard !== null ? scorecard.selected : true,
            creationDate: scorecard !== null ? scorecard.creationDate : null,
            scorecardGroup: scorecard !== null ? scorecard.scorecardGroup.id : null,
            generalGroup: scorecard !== null ? scorecard.scorecardGroup.generalGroup : null,
            settingItems: scorecard !== null ? UtilityScorecard.cleanSettingItems(scorecard.settingItems) : defaultSettingItems
        }

    }

    refetchQueryVersions = null;
    numberOfVersions = 1

    refreshVersions = () => {
        if (this.refetchQueryVersions !== null) {
            this.refetchQueryVersions()
        }
    }

    componentDidMount() {
        this.props.apol
            .query({
                query: getSearchAreaTypeEnum,
            })
            .then((result) => {
                var areas = result.data.getSearchAreaTypeEnum;
                var allAvailableAreas = areas.filter(area =>
                    area.name !== "Keywords" && area.name !== "Categories" && area.name !== "Patterns"
                ).map(r => {
                    return {
                        "key": r.name,
                        "text": this.context.getTranslation("compliance", r.name)
                    }
                })
                let availableAreas = this.state.automatedEvaluation ?
                    allAvailableAreas :
                    allAvailableAreas.filter(area => area.key === "QMQuestions")
                this.setState({
                    allAvailableAreas,
                    availableAreas
                })
            });
        this.refreshVersions()
    }

    change = (e, field) => {
        this.setState({ [field]: e.target.value, selectedOtherVersion: false })
    }


    addSection = () => {
        this.setState({
            sections: [...this.state.sections, { name: "", evaluationItems: [], isMultiQuestions: false }],
            selectedKeySection: [this.state.sections.length]
        })
    }

    addEvaluation = (section, indexSection) => {

        let newSections = this.state.sections.map((s, i) => {
            if (i === indexSection) {
                return (
                    {
                        name: s.name, evaluationItems: [...s.evaluationItems, {
                            name: "",
                            itemType: "",
                            itemId: "",
                            itemValue: "",
                            points: parseFloat(0),
                            awareOfPoints: false
                        }]
                    }
                )
            } else {
                return s
            }
        })
        this.setState({ sections: newSections, selectCriteria: null, selectedOtherVersion: false })

    }

    sortSections = (section, indexSection, direction) => {
        const sections = [...this.state.sections];
        const index = this.state.sections.indexOf(section);

        if (index === -1) {
            return;
        }

        if (direction === 'up' && index > 0) {
            [sections[index], sections[index - 1]] = [sections[index - 1], sections[index]];
        } else if (direction === 'down' && index < sections.length - 1) {
            [sections[index], sections[index + 1]] = [sections[index + 1], sections[index]];
        } else {
            return;
        }

        this.setState({ sections: sections });
    }


    isValid = () => {
        const checkName = this.state.name !== ""
        const chackNumberOfSections = this.state.sections.length > 0
        const checkSectionsName = this.state.sections.filter(s => s.name === "").length === 0
        let checkSectionsNameAreDifferent = true
        const checkNumberOfEvaluationItems = this.state.sections.filter(s => s.evaluationItems.length === 0).length === 0
        //check every evaluation item
        let checkEvaluationItems = true
        this.state.sections.forEach(s => {
            s.evaluationItems.forEach(e => {
                if (
                    e.itemType === "" ||
                    e.points < 0 ||
                    (e.itemType !== "QMQuestions" && e.itemType !== "ManualQMQuestions" && e.itemId === "") ||
                    (e.itemType === "QMQuestions" && e.itemValue === "") ||
                    (e.itemType === "ManualQMQuestions" && e.itemValue === "")
                ) {
                    checkEvaluationItems = false
                }
            })
        })
        checkSectionsNameAreDifferent = !(this.state.sections.some((item, index) =>
            this.state.sections.findIndex(obj => obj.name === item.name) !== index)
        );
        //check settings
        let checkSettingItems = true
        const regex = new RegExp("^[0-9]*$")
        this.state.settingItems.forEach(s => {
            if (s.name === "" || s.maxRange <= s.minRange || s.maxRange === "" || !regex.test(s.maxRange)) {
                checkSettingItems = false
            }
        })
        return checkName && chackNumberOfSections && checkSectionsName && checkNumberOfEvaluationItems && checkEvaluationItems && checkSettingItems && checkSectionsNameAreDifferent
    }

    validateCSVStructure = (data) => {
        const requiredHeaders = ['Section', 'Question', 'Type', 'Points'];

        for (let i = 0; i < data.length; i++) {
            const row = data[i];

            for (const header of requiredHeaders) {
                if (!(header in row)) {
                    return this.context.getTranslation("compliance", "csvMissingColumnError")
                }
                if (row[header]?.trim() === '') {
                    return this.context.getTranslation("compliance", "csvMissingValueError")
                }
            }

            if (isNaN(parseFloat(row['Points']))) {
                return this.context.getTranslation("compliance", "csvNotValidValueError")
            }

            const allowedTypes = ['Yes/No', 'Open', 'Manual'];
            if (!allowedTypes.includes(row['Type'].trim())) {
                return this.context.getTranslation("compliance", "csvMissingTypeError")
            }
        }

        return null;
    };

    handleFileChange = (event) => {
        if (event.target.files) {
            Papa.parse(event.target.files[0], {
                header: true,
                skipEmptyLines: true,
                delimiter: ",",
                complete: async (results) => {
                    const raw = results.data;

                    const error = this.validateCSVStructure(raw);
                    if (error) {
                        this.setState({ csvError: error });
                        return;
                    }

                    const sectionsMap = new Map();

                    raw.forEach((row) => {
                        const section = row['Section']?.trim();
                        const evalItem = {
                            name: "",
                            itemType: 'QMQuestions',
                            itemValue: row['Question'],
                            itemId: "",
                            points: parseFloat(row['Points']),
                            awareOfPoints: row['Type'] !== 'Yes/No',
                        };

                        if (!sectionsMap.has(section)) {
                            sectionsMap.set(section, []);
                        }

                        sectionsMap.get(section).push(evalItem);
                    });

                    const sections = Array.from(sectionsMap.entries()).map(([name, evaluationItems]) => ({
                        name,
                        evaluationItems,
                    }));

                    this.setState({ sections, csvError: null });
                }
            });
        }
    };



    handleIconButtonClick = () => {
        // If sections already exist, show a warning before overwriting
        if (this.state.sections.length > 0) {
            this.setState({ showTeachingBubbleUpload: true });
        } else {
            this.fileInput.click();
        }
    };


    save = (upsertToTemplate, saveAsNew) => {
        this.setState({ processing: true })
        const scorecard = {
            id: saveAsNew ? null : this.state.id,
            name: this.state.name,
            description: this.state.description,
            sections: this.state.sections,
            automatedEvaluation: this.state.automatedEvaluation,
            userId: this.props.userRules.userId,
            version: saveAsNew ? "1" : this.numberOfVersions.toString(),
            masterItemId: saveAsNew ? null : this.state.masterItemId,
            selected: this.state.selected,
            creationDate: this.state.creationDate,
            scorecardGroup: { id: this.state.scorecardGroup, generalGroup: this.state.generalGroup != null ? this.state.generalGroup : upsertToTemplate },
            settingItems: this.state.settingItems.map(x => {
                delete x.position; return {
                    ...x,
                    minRange: parseInt(x.minRange, 10),
                    maxRange: parseInt(x.maxRange, 10)
                }
            })
        }
        this.props.apol
            .mutate({
                mutation: updateScorecard,
                variables: { scorecard, upsertToTemplate }
            })
            .then((result) => {
                var resultData = result.data.upsertScorecard
                if (resultData.status === "ok") {
                    this.props.hidePanel()
                    this.props.updateScorecardId(resultData.id)
                    this.props.refreshScorecards()
                } else {
                    this.props.setMessageError(this.context.getTranslation("compliance", resultData.text))
                }
                this.setState({ processing: false })
            });
    }

    //VERSIONING

    onChangeVersion = (e, item) => {
        //get specific version to fill the fields
        this.setState({ processingVersion: true })
        let id = item.key
        this.props.apol
            .query({
                query: queryScorecard,
                variables: { id }
            })
            .then(({ loading, error, data, refetch }) => {
                let oldVersion = data.getScorecard;
                this.setState({
                    //scorecard data
                    name: oldVersion.name,
                    description: oldVersion.description,
                    userId: oldVersion.userId,
                    sections: UtilityScorecard.cleanSectionsItems(oldVersion.sections),
                    automatedEvaluation: oldVersion.automatedEvaluation,
                    creationDate: oldVersion.creationDate,
                    settingItems: UtilityScorecard.cleanSettingItems(oldVersion.settingItems),
                    //page data
                    selectedVersion: id,
                    selectedOtherVersion: true,
                    processingVersion: false
                })
            });
    }

    restoreVersion = () => {
        this.setState({ processing: true })
        //restoreScorecard -> id version to restore
        let id = this.state.selectedVersion
        this.props.apol
            .mutate({
                mutation: restoreScorecard,
                variables: { id }
            })
            .then((result) => {
                if (result.data.restoreScorecard.status === "ok") {
                    this.props.hidePanel()
                    this.props.updateScorecardId(id)
                    this.props.refreshScorecards()
                } else {
                    this.props.setMessageError(this.context.getTranslation("compliance", result.data.restoreScorecard.text))
                }
                this.setState({
                    selectedOtherVersion: false,
                    processing: false
                })
            });
    }

    render() {
        return (
            <div>
                {this.state.processingVersion && <div>
                    <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                </div>}
                {!this.state.processingVersion && <div>
                    {this.state.masterItemId !== null &&
                        <Query
                            query={getAllVersionOfScorecard}
                            variables={{ masterItemId: this.state.masterItemId }}>
                            {({ loading, error, data, refetch }) => {
                                this.refetchQueryVersions = refetch
                                if (loading) return <Spinner label={this.context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />
                                if (error) {
                                    console.log(error)
                                    return (
                                        <AlertBar message={this.context.getTranslation("compliance", "error")} alertType="error" />
                                    );
                                }
                                if (data.getAllVersionOfScorecard == null) {
                                    return <AlertBar message={this.context.getTranslation("common", "noData")} alertType={"warning"} />
                                }
                                let versions = data.getAllVersionOfScorecard.map(v => {
                                    return {
                                        "key": v.id,
                                        "text": v.version
                                    }
                                })
                                this.numberOfVersions = versions.length
                                return (<div>
                                    {versions.length > 0 &&
                                        <Dropdown
                                            label={this.context.getTranslation("compliance", "version")}
                                            selectedKey={this.state.selectedVersion}
                                            onChange={this.onChangeVersion}
                                            options={versions}
                                        />
                                    }
                                </div>
                                )
                            }}
                        </Query>}
                    <TextField label={this.context.getTranslation("compliance", "name")} value={this.state.name} onChange={(e) => this.change(e, "name")} required />
                    <TextField label={this.context.getTranslation("compliance", "description")} value={this.state.description} onChange={(e) => this.change(e, "description")} />
                    {this.state.csvError && (
                        <AlertBar
                            message={this.state.csvError}
                            alertType={"warning"}
                        />
                    )}
                    <Stack style={{ marginTop: "15px" }}>
                        {this.state.alertAutomatedEvaluation && <TeachingBubble
                            target={`#${"automatedEvaluation"}`}
                            secondaryButtonProps={{
                                children: this.context.getTranslation("common", "no"),
                                onClick: () => {
                                    this.setState({ alertAutomatedEvaluation: false })
                                }
                            }}
                            primaryButtonProps={{
                                children: this.context.getTranslation("common", "yes"),
                                onClick: () => {
                                    this.fileInput.value = null;
                                    let availableAreas = []
                                    let checked = !this.state.automatedEvaluation
                                    if (!checked) {
                                        availableAreas = this.state.allAvailableAreas.filter(area => area.key === "QMQuestions")
                                    } else {
                                        availableAreas = this.state.allAvailableAreas
                                    }
                                    this.setState({
                                        automatedEvaluation: checked,
                                        selectedOtherVersion: false,
                                        availableAreas,
                                        sections: [],
                                        alertAutomatedEvaluation: false
                                    })
                                }
                            }}
                        >
                            {this.context.getTranslation("compliance", "alertAutomatedEvaluation")}
                        </TeachingBubble>}
                        <Toggle
                            id="automatedEvaluation"
                            checked={this.state.automatedEvaluation}
                            onText={this.context.getTranslation("compliance", "automatedEvaluation")}
                            offText={this.context.getTranslation("compliance", "manualEvaluation")}
                            onChange={(e, checked) => {
                                if (this.state.sections.length > 0) {
                                    this.setState({ alertAutomatedEvaluation: true })
                                } else {
                                    let availableAreas = []
                                    if (!checked) {
                                        availableAreas = this.state.allAvailableAreas.filter(area => area.key === "QMQuestions")
                                    } else {
                                        availableAreas = this.state.allAvailableAreas
                                    }
                                    this.setState({
                                        automatedEvaluation: checked,
                                        selectedOtherVersion: false,
                                        availableAreas,
                                        sections: []
                                    })
                                }
                            }}
                        />
                    </Stack>
                    <Stack
                        horizontal
                        verticalAlign="center"
                        styles={{
                            root: {
                                width: "100%", // fa espandere lo Stack orizzontale
                                justifyContent: "space-between", // spinge prima e ultima sezione ai bordi
                            },
                        }}
                    >
                        <Stack horizontal verticalAlign="center">
                            <Stack.Item style={{ marginTop: "5px", marginRight: "5px" }}>
                                <ScorecardFolding
                                    selectedKey={this.state.selectedKey}
                                    selected={"elements"}
                                    open={() => {
                                        this.setState({
                                            selectedKey: [...this.state.selectedKey, "elements"],
                                        });
                                    }}
                                    close={() => {
                                        this.setState({
                                            selectedKey: this.state.selectedKey.filter((s) => s !== "elements"),
                                        });
                                    }}
                                />
                            </Stack.Item>
                            <Stack.Item>
                                <h4 style={{ margin: 0 }}>
                                    {this.context.getTranslation("compliance", "criteria")}
                                </h4>
                            </Stack.Item>
                        </Stack>

                        <Stack.Item>
                            <div
                                style={{
                                    position: 'relative',
                                    display: 'inline-block',
                                    backgroundColor: this.state.isHovered ? '#f3f3f3' : 'transparent',
                                    borderRadius: 4,
                                    cursor: 'pointer',
                                }}
                                onMouseEnter={() => this.setState({ isHovered: true })}
                                onMouseLeave={() => this.setState({ isHovered: false })}
                            >
                                <IconButton
                                    id="uploadButton"
                                    iconProps={this.fileInput && this.fileInput.value ? { iconName: "Attach" } : { iconName: "Upload" }}
                                    title=""
                                    onClick={this.handleIconButtonClick}
                                />
                            </div>
                            <input
                                ref={(input) => {
                                    this.fileInput = input;
                                }}
                                type="file"
                                onChange={this.handleFileChange}
                                accept=".csv"
                                style={{ display: "none" }}
                            />
                        </Stack.Item>
                    </Stack>




                    {this.state.selectedKey.includes("elements") && <Stack style={{ marginTop: "5px" }}>
                        <Stack>
                            <Stack.Item>
                                <CommandBarButton style={{ marginBottom: "5px", padding: "7px" }}
                                    text={this.context.getTranslation("compliance", "addSection")}
                                    iconProps={{ iconName: 'Add' }}
                                    onClick={this.addSection} />
                            </Stack.Item>

                            {
                                //MANAGE SECTIONS
                                this.state.sections.map((section, indexSection) => {
                                    return <EditScorecardSection
                                        key={"section" + indexSection}
                                        section={section}
                                        selectCriteria={this.state.selectCriteria}
                                        sortSections={(section, indexSection, direction) => this.sortSections(section, indexSection, direction)}
                                        addEvaluation={(section, indexSection, criteria) => this.addEvaluation(section, indexSection, criteria)}
                                        indexSection={indexSection}
                                        isLastSection={indexSection === this.state.sections.length - 1}
                                        availableAreas={this.state.availableAreas}
                                        updateSection={(sec, index, action) => {
                                            let newSections = null
                                            if (action === "delete") {
                                                newSections = this.state.sections.filter((item, i) => i !== index)
                                            }
                                            if (action === "update") {
                                                newSections = this.state.sections.map((item, i) => {
                                                    if (i === index) {
                                                        return sec
                                                    } else {
                                                        return item
                                                    }
                                                })
                                            }
                                            this.setState({ sections: newSections, selectedOtherVersion: false })
                                        }}
                                        selectedKeySection={this.state.selectedKeySection}
                                        updateSelectedKeySection={(selectedKeySection) => {
                                            this.setState({ selectedKeySection })
                                        }}
                                        automatedEvaluation={this.state.automatedEvaluation}
                                    />
                                })
                            }
                        </Stack>
                        <Separator className="separator" />
                    </Stack>}
                    <Stack horizontal>
                        <Stack.Item style={{ marginTop: "5px", marginRight: "5px" }}>
                            <ScorecardFolding
                                selectedKey={this.state.selectedKey}
                                selected={"settings"}
                                open={() => {
                                    this.setState({
                                        selectedKey: [...this.state.selectedKey, "settings"]
                                    })
                                }}
                                close={() => {
                                    this.setState({
                                        selectedKey: this.state.selectedKey.filter(s => s !== "settings")
                                    })
                                }}
                            />
                        </Stack.Item>

                        <Stack.Item>
                            <h4>{this.context.getTranslation("compliance", "scorecardSettings")}</h4>
                        </Stack.Item>
                    </Stack>
                    {this.state.selectedKey.includes("settings") &&
                        <Stack>
                            <Stack horizontal styles={{ root: { height: 44 } }}>
                                <CommandBarButton
                                    styles={{ root: { marginTop: 10 } }}
                                    iconProps={{ iconName: 'Add' }}
                                    text={this.context.getTranslation("compliance", "addEvaluationSetting")}
                                    disabled={false}
                                    checked={false}
                                    onClick={() => {
                                        this.setState((prevState) => {
                                            const lastItem = prevState.settingItems[prevState.settingItems.length - 1];
                                            const newSettingItem = {
                                                name: "",
                                                position: prevState.settingItems.length,
                                                maxRange: 1,
                                                minRange: 0,
                                                color: "#ffffff"
                                            };
                                            let newSettings = prevState.settingItems.map(x => ({ ...x, minRange: x.position === lastItem.position ? 1 : x.minRange }))
                                            return {
                                                settingItems: [...newSettings, newSettingItem]
                                            };
                                        });
                                    }}
                                />
                            </Stack>
                            <EditScorecardSettings
                                settingItems={this.state.settingItems}
                                updateSettingItems={(settingItems) => this.setState({ settingItems })}
                                deleteSettingItem={(deletedItem) => {
                                    let newItems = this.state.settingItems.filter(s => s.position !== deletedItem.position)
                                    newItems = newItems.map((item, i) => {
                                        return {
                                            ...item,
                                            position: i,
                                            maxRange: item.position == deletedItem.position + 1 ? deletedItem.maxRange : item.maxRange,
                                            minRange: deletedItem.position == this.state.settingItems.length - 1 && item.position == newItems.length - 1 ? deletedItem.minRange : item.minRange
                                        };
                                    });
                                    this.setState({ settingItems: newItems })
                                }}
                            />
                        </Stack>
                    }
                    {/*FOOTER BUTTONS*/}
                    <Stack horizontal style={{ flexFlow: "row-reverse" }}>
                        <DefaultButton
                            text={this.context.getTranslation("common", "cancel")}
                            onClick={() => { this.props.hidePanel() }}
                            style={{ marginTop: "30px", marginLeft: "15px" }}
                            disabled={this.state.processing}
                        />
                        {(!this.state.selectedOtherVersion || this.state.id === this.state.selectedVersion) &&
                            <PrimaryButton
                                text={this.context.getTranslation("common", "save")}
                                onClick={() => this.save(false, false)}
                                style={{ marginTop: "30px", marginLeft: "15px" }}
                                disabled={!this.isValid() || this.state.processing}
                            />
                        }
                        {(!this.state.selectedOtherVersion || this.state.id === this.state.selectedVersion) &&
                            this.state.id !== null &&
                            <PrimaryButton
                                text={this.context.getTranslation("compliance", "saveAsNew")}
                                onClick={() => this.save(false, true)}
                                style={{ marginTop: "30px", marginLeft: "15px" }}
                                disabled={!this.isValid() || this.state.processing}
                            />
                        }
                        {(this.props.userRules.userTemplateAllowed && (!this.state.selectedOtherVersion || this.state.id === this.state.selectedVersion)) &&
                            <PrimaryButton
                                text={this.context.getTranslation("common", "saveAsTemplate")}
                                onClick={() => this.save(true, false)}
                                style={!this.isValid() || this.state.processing ?
                                    { marginTop: "30px", marginLeft: "15px" } :
                                    { marginTop: "30px", marginLeft: "15px", background: "red", color: "white" }}
                                allowDisabledFocus={true}
                                disabled={!this.isValid() || this.state.processing}
                            />
                        }
                        {this.state.selectedOtherVersion && this.state.id !== this.state.selectedVersion &&
                            <PrimaryButton
                                text={this.context.getTranslation("compliance", "restoreVersion")}
                                onClick={this.restoreVersion} style={{ marginTop: "30px", marginLeft: "15px" }}
                                disabled={!this.isValid() || this.state.processing}
                            />
                        }
                    </Stack>
                </div>}
                {this.state.showTeachingBubbleUpload &&
                    <Layer>
                        <TeachingBubble
                            target="#uploadButton"
                            primaryButtonProps={{
                                children: this.context.getTranslation("common", "yes"),
                                onClick: () => {
                                    this.setState({ showTeachingBubbleUpload: false });
                                    this.fileInput.click();
                                }
                            }}
                            secondaryButtonProps={{
                                children: this.context.getTranslation("common", "no"),
                                onClick: () => {
                                    this.setState({ showTeachingBubbleUpload: false });
                                }
                            }}
                            hasCloseButton
                            onDismiss={() => this.setState({ showTeachingBubbleUpload: false })}
                        >
                            {this.context.getTranslation("compliance", "alertUploadScorecard")}
                        </TeachingBubble>
                    </Layer>
                }
            </div>
        )
    }
}